import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import IconButton from '../IconButton';
import MenuIcon from '../Icons/Menu';

const MenuButton = () => {
  const { ui } = useStores();
  const {
    header: {
      title: { color, iconColor }
    }
  } = useConfig();
  const { i18n, t } = useTranslation();

  const menuClick = () => {
    const element = document.querySelector('#headerMenu');
    if (element.style.display === 'none' || element.style.display === '') {
      ui.closeHeaderMenuModal();
      element.style.display = 'flex';
    } else {
      element.style.display = 'none';
    }
  };

  return (
    <>
      <IconButton onClick={menuClick} title={i18n.exists('altText.menu') ? t('altText.menu') : ''}>
        <MenuIcon fill={iconColor || color} style={{ marginRight: '10px' }} />
      </IconButton>
    </>
  );
};

export default observer(MenuButton, { forwardRef: true });
